import React from 'react';
import { Box, Typography } from '@mui/material';
import { GT_COLORS } from './constants';

interface StatCardProps {
    value: number | string;
    label: string;
    valueColor?: string;
    onClick?: () => void;
}

export const StatCard: React.FC<StatCardProps> = ({ value, label, valueColor, onClick }) => {
    return (
        <Box
            onClick={onClick}
            sx={{
                flex: 1,
                backgroundColor: GT_COLORS.cardBg,
                borderRadius: '8px',
                border: `1px solid ${GT_COLORS.border}`,
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'baseline',
                gap: '8px',
                ...(onClick ? { cursor: 'pointer', '&:hover': { borderColor: GT_COLORS.primary, backgroundColor: '#f8faff' } } : {}),
            }}
        >
            <Typography
                sx={{
                    fontSize: '22px',
                    fontWeight: 700,
                    lineHeight: 1,
                    color: valueColor || GT_COLORS.primary,
                }}
            >
                {typeof value === 'number' ? value.toLocaleString() : value}
            </Typography>
            <Typography
                sx={{
                    fontSize: '12px',
                    color: GT_COLORS.textFaint,
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '.4px',
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};
